import React from "react";
import { Routes, Route } from "react-router-dom";
import SearchHome from "./search-home";
import SearchQueryHome from "./search-query-home";

//
const Search = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<SearchHome />} />
        <Route path="/" element={<SearchHome />} />
        <Route path="/q/:query" element={<SearchQueryHome />} />
      </Routes>
    </React.Fragment>
  );
};

export default Search;
